























































































































































































































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";

import store, { MetRiportStore } from "../services/MetRiportStore";
import MetRiportItem from "../models/MetRiportItem";
import pcCodeStore, { PcCodeStore } from "@/modules/pcCode/services/PcCodeStore";
import globalStore, { GlobalStore } from "@/models/GlobalStore";
import MetRiportItemDetails from "./MetRiportItemDetails.vue";

interface Data {
    store: MetRiportStore;
    pcCodeStore: PcCodeStore;
    globalStore: GlobalStore;
    loading: boolean;
    eventBus: any;
}

interface Methods {
    updateItem(item: MetRiportItem): void;
    removeItem(id: number): void;
    setItemState(item: MetRiportItem, itemState: string): void;
    setItems(items: any): void;
}

interface Computed {
    columns: ApiSearchColumn[];
    url: string;
    dmsCodeCodeInfo: (dmsCode: string) => string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: {
        ApiSearchPage,
        IconButton,
        MetRiportItemDetails,
    },

    async beforeMount() {
        this.loading = true;
        this.store.showNotMappedCodes = false;
        await store.loadItemTypes();
        await pcCodeStore.loadStore();
        this.loading = false;
    },

    data() {
        return {
            store,
            pcCodeStore,
            globalStore: globalStore,
            loading: false,
            eventBus,
        };
    },

    methods: {
        async updateItem(item: MetRiportItem) {
            await store.updateMetRiportItem(item);
            (this.$refs.metRiportItemApiSearch as any).refreshClick();
        },
        async removeItem(id: number) {
            await store.removeMetRiportItem(id);
            (this.$refs.metRiportItemApiSearch as any).refreshClick();
        },
        setItemState(item, itemState) {
            if (itemState == globalStore.itemState.InEdit) {
                item.selected = false;
                item.inEdit = !item.inEdit;
                item.showDetails = false;
                item.selectToRemove = false;
            } else if (itemState == globalStore.itemState.SelectToRemove) {
                item.selected = !item.selected;
                item.selectToRemove = !item.selectToRemove;
                item.showDetails = false;
                item.inEdit = false;
            } else if (itemState == globalStore.itemState.ShowDetails) {
                item.selected = !item.selected;
                item.showDetails = !item.showDetails;
                item.selectToRemove = false;
                item.inEdit = false;
            }
        },
        async setItems(items) {
            await this.$set(this.store, 'metRiportItems', items);
            this.store.notMappedItemsCount = this.store.metRiportItems?.[0]?.notMappedCount ?? 0
        }
    },

    computed: {
        url() {
            return `met-riport/${Number(this.$route.params["metRiportId"]) || 0}/items/search/${store.showNotMappedCodes}`;
        },
        columns: function() {
            return [
                {
                    field: "id",
                    title: "",
                    cell: 'command',
                    headerClass: "detailsColumn",
                    filterable: false,
                    sortable: false,
                },
                {
                    field: "name",
                    title: "Név",
                    cell: "name",
                },
                {
                    field: "metisCode",
                    title: "Metis kód",
                    cell: "metisCode"
                },
                {
                    field: "metType",
                    title: "Metis típusa",
                    cell: "metType",
                    multiselect: true,
                    multiselectField: "selectedMetisTypes",
                    multiselectOptions: store.itemTypes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    })),
                },
                {
                    field: "notPcCode",
                    title: "DMS Kód nélkül?",
                    cell: "notPcCode",
                },
                {
                    field: "dmsCode",
                    title: "DMS kód",
                    cell: "dmsCode",
                    type: ColumnType.Right
                },
                {
                    field: "accCode",
                    title: "Főkönyvi szám",
                    cell: "accCode",
                    type: ColumnType.Right
                },
                {
                    field: "pcCode1",
                    title: "Telephely",
                    cell: "pcCode1",
                    // filterable: false,
                    // sortable: false,
                    type: ColumnType.Right
                },
                {
                    field: "pcCode2",
                    title: "Gyártmány",
                    cell: "pcCode2",
                    // filterable: false,
                    // sortable: false,
                    type: ColumnType.Right
                },
                {
                    field: "pcCode3",
                    title: "Modell",
                    cell: "pcCode3",
                    // filterable: false,
                    // sortable: false,
                    type: ColumnType.Right
                },
                {
                    field: "pcCode4",
                    title: "Részleg",
                    cell: "pcCode4",
                    // filterable: false,
                    // sortable: false,
                    type: ColumnType.Right
                },
                {
                    field: "pcCode5",
                    title: "Értékesítés neme",
                    cell: "pcCode5",
                    // filterable: false,
                    // sortable: false,
                    type: ColumnType.Right
                },
                {
                    field: "pcCode6",
                    title: "GJ fajta",
                    cell: "pcCode6",
                    // filterable: false,
                    // sortable: false,
                    type: ColumnType.Right
                },
                {
                    field: "calcWithDefault",
                    title: "Alapért. értékkel számoljon?",
                    cell: "calcWithDefault",
                },
                {
                    field: "defaultValue",
                    title: "Alapért. érték",
                    cell: "defaultValue",
                    type: ColumnType.Right
                },
            ];
        },
        dmsCodeCodeInfo(): (dmsCode: string) => string {
            return (dmsCode: string): string => {
                if (dmsCode === null || dmsCode.length < 6) return "";
                const parts = dmsCode.split("_");
                const accNo = parts[0];
                const pcString = parts[1];

                return `Fk. szám: ${accNo}*
                        Telephely: ${this.pcCodeStore.getName(this.pcCodeStore.depots, pcString[0])}
                        Gyártmány: ${this.pcCodeStore.getName(this.pcCodeStore.carBrands, pcString[1])}
                        Modell: ${this.pcCodeStore.getName(this.pcCodeStore.metisModells, `${pcString[2]}${pcString[3]}`)}
                        Részleg: ${this.pcCodeStore.getName(this.pcCodeStore.accInvGroups, `${pcString[4]}${pcString[5]}`)}
                        Értékesítés neme: ${this.pcCodeStore.getName(this.pcCodeStore.salesTypes, pcString[6])}
                        Gj. fajta: ${this.pcCodeStore.getName(this.pcCodeStore.carCategories, pcString[7])}`;
            };
        }
    },
});
